// import {
//   countries as countriesData,
//   timeZone,
// } from "../../../resources/LocationData";
import { useEffect, useState } from "react";
import Styles from "./locationStyle.module.css";
import { toast, ToastContainer } from "react-toastify";
import { CiEdit } from "react-icons/ci";
import {
  DatePicker,
  Select,
  Button,
  Form,
  Input,
  Checkbox,
} from "antd";

const PreLiveDetailsComponent = ({ preLiveDetails, setPreLiveDetails, isApprover, approvalStage, siteStatus, setSiteStatus, isApproverView }) => {
  const [form] = Form.useForm();
    const { Option } = Select;  
  

  const submitForm = (isCompleted) => {
    if (isCompleted) {
      if (
        Object.values(preLiveDetails).filter((value) => value !== null)
          .length === Object.values(preLiveDetails).length
      ) {
        form.submit();
        setPreLiveDetails((prev) => ({
          ...prev,
          isSectionCompleted: true,
        }));
        // Submit the form
      } else {
        setPreLiveDetails((prev) => ({
          ...prev,
          isSectionCompleted: false,
        }));
        // Reset the checkbox in the form
        form.setFieldsValue({
          isSectionCompleted: false,
        });

        toast.error(
          "Please fill all the details before marking the section as completed."
        );
      }
    }
  };


  return (
    <div className={Styles[`main-div`]}>
      <div className={Styles["location-head-div"]}>
        <div>
          <span>
            {" "}
            {preLiveDetails?.isSectionCompleted && isApprover && (
              <Button
                className={Styles["edit-btn"]}
                disabled={!preLiveDetails?.isSectionCompleted || siteStatus === "Live" || approvalStage !== 'Approved'}
                onClick={() => {
                  setPreLiveDetails((prev) => ({
                    ...prev,
                    isSectionCompleted: false,
                  }));
                  form.setFieldsValue({
                    isSectionCompleted: false,
                  });
                }}
              >
                {" "}
                <CiEdit  
                  className={Styles["location-edit-icon"]}
                />{" "}
                Edit
              </Button>
            )}
          </span>
        </div>
      </div>

      <Form
        className={Styles["form-grid"]}
        form={form}
        initialValues={preLiveDetails}
        disabled={preLiveDetails?.isSectionCompleted || (approvalStage === "PendingApproval" && isApprover === false) || siteStatus !== 'Pre Live' || isApprover === false}
      >

        <Form.Item
          label="CSMS Connected"
          name="csmsConnected"
          rules={[{ required: true, message: "Please input CSMS connection status!" }]}>
          <Select
                      // value={locationDetails?.country}
                      onChange={(value) => {
                        setPreLiveDetails((prev) => ({
                          ...prev,
                          csmsConnected: value,
                        }));
                      }}
                      placeholder="CSMS Connection status"
                      allowClear
                    >
                        <Option value="Yes(CSMS Breathe)">Yes(CSMS Breathe)</Option>
                        <Option value="Yes(EDRv)">Yes(EDRv)</Option>
                        <Option value="No">No</Option>
                    </Select>
        </Form.Item>

        <Form.Item
          name="csmsConnectionDate"
          label="CSMS Connection Date"
          rules={[{ required: true, message: "Please input CSMS connection date!" }]}
        >
          <DatePicker onChange={(date)=>{
            setPreLiveDetails(prev => ({
              ...prev,
              csmsConnectionDate: date ? new Date(date) : null
            }))
          }}/>
        </Form.Item>

        <Form.Item
          name="siteLiveDate"
          label="Site Live Date"
          rules={[{ required: true, message: "Please input site live date!" }]}
        >
          <DatePicker onChange={(date)=>{
            setPreLiveDetails(prev => ({
              ...prev,
              siteLiveDate: date ? new Date(date) : null
            }))
          }}/>
        </Form.Item>

        <Form.Item name="plugShareUpdated" label="PlugShare updated?" >

          <Select value={preLiveDetails.plugShareUpdated} onChange={value => setPreLiveDetails(prev => ({
            ...prev,
            plugShareUpdated: value
          }))}>
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>

          </Select>

          {/* <Checkbox
            onChange={(e) => {
                setPreLiveDetails(prev => ({
                  ...prev,
                  plugShareUpdated: e.target.checked
              }));
              
            }}
          >
            {" "}
            PlugShare Updated.
          </Checkbox> */}
        </Form.Item>

        <Form.Item name="GoogleMapUpdated" label="Google Map Updated?">
          <Select value={preLiveDetails.GoogleMapUpdated} onChange={value => setPreLiveDetails(prev => ({
            ...prev,
            GoogleMapUpdated: value
          }))}>
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>

          </Select>
          {/* <Checkbox
            onChange={(e) => {
                setPreLiveDetails(prev => ({
                  ...prev,
                  GoogleMapUpdated: e.target.checked
              }));
              
            }}
          >
            {" "}
            Google Map Updated.
          </Checkbox> */}
        </Form.Item>

        <Form.Item name="appleMapUpdated" label="Apple Map Updated?" >
          <Select value={preLiveDetails.appleMapUpdated} onChange={value => setPreLiveDetails(prev => ({
            ...prev,
            appleMapUpdated: value
          }))}>
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>

          </Select>
          {/* <Checkbox
            onChange={(e) => {
                setPreLiveDetails(prev => ({
                  ...prev,
                  appleMapUpdated: e.target.checked
              }));
              
            }}
          >
            {" "}
            Apple Map Updated.
          </Checkbox> */}
        </Form.Item>

        <Form.Item name="propertyManagerOnboarded" label="Property manager onboarded?">
          <Select value={preLiveDetails.propertyManagerOnboarded} onChange={value => setPreLiveDetails(prev => ({
            ...prev,
            propertyManagerOnboarded: value
          }))}>
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>

          </Select>
          {/* <Checkbox
            onChange={(e) => {
                setPreLiveDetails(prev => ({
                  ...prev,
                  propertyManagerOnboarded: e.target.checked
              }));
              
            }}
          >
            {" "}
            Property Manager Onboarded.
          </Checkbox> */}
        </Form.Item>

        <Form.Item name="propertyEmailSent" label="Property email sent?" >
          <Select value={preLiveDetails.propertyEmailSent} onChange={value => setPreLiveDetails(prev => ({
            ...prev,
            propertyEmailSent: value
          }))}>
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>

          </Select>
          {/* <Checkbox
            onChange={(e) => {
                setPreLiveDetails(prev => ({
                  ...prev,
                  propertyEmailSent: e.target.checked
              }));
              
            }}
          >
            {" "}
            Property Email Sent.
          </Checkbox> */}
        </Form.Item>




        {isApprover &&  <Form.Item className={Styles["full-width"]} name="isSectionCompleted" valuePropName="checked">
          <Checkbox
            disabled={
              Object.values(preLiveDetails).filter((value) => value !== null)
                .length /
                Object.values(preLiveDetails).length <
                1 || preLiveDetails?.isSectionCompleted
            }
            onChange={(e) => {
              submitForm(e.target.checked);
            }}
          >
            {" "}
            Verified and Completed.
          </Checkbox>
        </Form.Item>}
      </Form>
    </div>
  );
};
export default PreLiveDetailsComponent;
